import { Link } from 'react-router'

export function EquipoPage() {
  return (
    <div className="legal-page">
      <div className="legal-inner">
        <h1 className="legal-title">Sobre Hemiciclo</h1>

        <section className="legal-section">
          <h2>Por qué existe este sitio</h2>
          <p>El Congreso de Chile genera cientos de votaciones cada mes. Cada proyecto de ley pasa por comisiones, discusiones y votaciones en ambas cámaras. Toda esa información es pública — pero encontrarla y entenderla no es fácil para el ciudadano común.</p>
          <p>Hemiciclo nace de una pregunta simple: <strong>¿cómo votó mi parlamentario?</strong></p>
          <p>Responder esa pregunta no debería requerir navegar múltiples sitios, interpretar formatos técnicos, ni entender la jerga legislativa. Debería ser tan fácil como buscar el nombre de un proyecto y ver qué pasó.</p>
        </section>

        <section className="legal-section">
          <h2>Qué buscamos</h2>
          <ul>
            <li><strong>Saber en qué va un proyecto de ley</strong> — desde que ingresa al Congreso hasta que se convierte en ley (o se archiva).</li>
            <li><strong>Ver cómo votó cada parlamentario</strong> — nombre por nombre, partido por partido, sin filtros.</li>
            <li><strong>Entender cómo votan los partidos</strong> — si votaron unidos, si se dividieron, quién se desmarcó.</li>
            <li><strong>Que cualquier persona pueda entenderlo</strong> — sin necesidad de ser abogado, politólogo ni periodista.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Quién está detrás</h2>
          <p>Hemiciclo es un proyecto personal creado y mantenido por un ciudadano chileno. No hay empresa, fundación ni organización detrás — solo la convicción de que la información legislativa debe ser accesible para todos.</p>
          <p>Si tienes preguntas, sugerencias o quieres colaborar, escribe a <a href="mailto:contacto@hemiciclo.cl">contacto@hemiciclo.cl</a>.</p>
        </section>

        <Link to="/" className="legal-back">← Volver al inicio</Link>
      </div>
    </div>
  )
}
